"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var _ = require("lodash");
var finding_1 = require("./finding");
var sorting_1 = require("./sorting");
var Mapping = (function () {
    function Mapping() {
    }
    Mapping.mapTeaserCruises = function (cruises, promoCruise) {
        _.remove(cruises, function (cruise) { return cruise.campaignFocus === 'NLS'; });
        return _.map(cruises, function (cruise) { return Mapping.mapCruise(cruise, promoCruise); });
    };
    Mapping.getCategory = function (cruise, promoCategory) {
        var promoPrice = Mapping.getPrice(cruise, promoCategory);
        if (promoPrice)
            return promoCategory;
        var category = cruise.promotionCategories.length
            ? cruise.promotionCategories[0]
            : cruise.cabinPrices.length
                ? cruise.cabinPrices[0].id
                : '';
        return category;
    };
    Mapping.getPrice = function (cruise, category) {
        return _.find(cruise.cabinPrices, ['id', category]);
    };
    Mapping.mapCruise = function (cruise, promoCruise) {
        var flightConnection = Mapping.mapFlightCode(cruise.flight, cruise.mandatoryFlight);
        var promoCruiseId = promoCruise.cruiseID;
        var promoCabinCat = Mapping.getCategory(cruise, promoCruise.promotionCategories[0]);
        var cabinPrice = Mapping.getPrice(cruise, promoCabinCat);
        var priceOk = cabinPrice && cabinPrice.price && cabinPrice.available;
        var price = cabinPrice && priceOk ? cabinPrice.price / 2 : 0;
        var cabinCategory = _.find(cruise.cabinCategories, ['id', promoCabinCat]);
        var surchargesCC = _.get(cabinCategory, 'surcharges', []);
        var amenitiesCC = _.get(cabinCategory, 'amenities', []);
        var surcharges = Mapping.mapSurcharges(surchargesCC);
        var amenities = Mapping.mapAmenities(amenitiesCC);
        var mappedSurcharges = surcharges.length ? surcharges : amenities;
        var priceInfo = {
            amount: price,
            priceModel: cruise.priceModel,
            surcharges: mappedSurcharges,
        };
        var journeys = _.get(cruise, 'journeys', undefined);
        var regionIds = journeys ? [journeys[0].regionID] : [];
        var imageDefault = { alt: {}, file: '', keywords: [], uid: '' };
        var cruiseShip = finding_1.Finding.findShip(cruise);
        var routeImage = __assign({}, imageDefault, { file: cruise.itinerary[0].mapImageUrl });
        var ship = {
            id: _.get(cruiseShip, 'id', ''),
            image: _.get(cruiseShip, 'teaserImage', imageDefault),
            name: _.get(cruiseShip, 'name', ''),
        };
        return {
            cabinPrices: cruise.cabinPrices,
            campaignFocus: cruise.campaignFocus,
            code: cruise.cruiseID,
            datesDisplay: cruise.startDate + ' bis ' + cruise.endDate,
            endDate: cruise.endDate,
            flightConnection: flightConnection,
            flightInclusive: cruise.mandatoryFlight,
            price: price,
            priceInfo: priceInfo,
            promotion: cruise.cruiseID === promoCruiseId ? true : false,
            regionIds: regionIds,
            routeImage: routeImage,
            ship: ship,
            startDate: cruise.startDate,
        };
    };
    Mapping.mapAmenities = function (amenities) {
        if (!amenities.length) {
            return [];
        }
        var filteredOBC = _.filter(amenities, { type: 'BGH' });
        var filteredId = _.filter(amenities, { id: 'YKESPA00' });
        if (!filteredOBC.length && !filteredId.length) {
            return [];
        }
        var mappedAmenities = [];
        if (filteredOBC.length) {
            var sumOBC = _.sumBy(filteredOBC, 'amount');
            var amenityOBC = {
                amount: sumOBC,
                description: 'BGH',
                id: 'OBC',
                type: 'BGH',
            };
            mappedAmenities.push(amenityOBC);
        }
        if (filteredId.length) {
            var amenitySSV = {
                amount: 0,
                description: 'inkl. Wellnesspaket',
                id: 'YKESPA00',
                type: 'SPECPKG',
            };
            mappedAmenities.push(amenitySSV);
        }
        return mappedAmenities;
    };
    Mapping.mapSurcharges = function (surcharges) {
        if (!surcharges.length) {
            return [];
        }
        var typeEB = _.filter(surcharges, { type: 'EB' });
        var sumEB = _.sumBy(typeEB, 'amount');
        var earlyBird = typeEB.length
            ? {
                amount: sumEB,
                id: 'EB',
                type: 'EB',
            }
            : undefined;
        var typeEBP = _.filter(surcharges, { type: 'EBP' });
        var sumEBP = _.sumBy(typeEBP, 'amount');
        var earlyBirdPlus = typeEBP.length
            ? {
                amount: sumEBP,
                id: 'EBP',
                type: 'EBP',
            }
            : undefined;
        return earlyBird
            ? [earlyBird]
            : earlyBirdPlus
                ? [earlyBirdPlus]
                : surcharges;
    };
    Mapping.mapTeaserOffer = function (cruise, offers) {
        var imageDefault = { alt: {}, file: '', keywords: [], uid: '' };
        var startPort = finding_1.Finding.findStartPort(cruise);
        var endPort = finding_1.Finding.findEndPort(cruise);
        var cabinCategories = cruise.cabinCategories;
        var promoCategories = cruise.promotionCategories;
        var promoCategory = finding_1.Finding.findPromoCategory(cabinCategories, promoCategories);
        var cruiseOffers = Mapping.mapTeaserCruises(offers, cruise);
        var cruises = sorting_1.Sorting.sortTeaserCruises(cruiseOffers);
        if (!cruises[0]) {
            return;
        }
        var amenities = Mapping.mapAmenities(_.get(promoCategory, 'amenities', []));
        var cabinCategoryOffer = {
            code: _.get(promoCategory, 'id', ''),
            image: _.get(promoCategory, 'image', ''),
            name: _.get(promoCategory, 'mainName', ''),
        };
        var cheapestPrice = cruise.price ? cruise.price : 0;
        var cheapestCruiseIndex = 0;
        var cabinCategory = _.find(cruise.cabinCategories, ['id', promoCategory]);
        var surchargesCC = _.get(cabinCategory, 'surcharges', []);
        var priceInfo = {
            amount: cheapestPrice,
            priceModel: cruise.priceModel,
            surcharges: Mapping.mapSurcharges(surchargesCC),
        };
        var regionIds = cruises[0].regionIds;
        return {
            amenities: amenities,
            bookableUntil: cruise.bookableUntil,
            cabinCategoryOffer: cabinCategoryOffer,
            cheapestCruiseIndex: cheapestCruiseIndex,
            cheapestPrice: cheapestPrice,
            cruises: cruises,
            duration: cruise.duration,
            endPort: _.get(endPort, 'name', ''),
            itineraryId: _.get(cruise, 'itinerary[0].id', ''),
            portImage: _.get(startPort, 'teaserImage', imageDefault),
            priceInfo: priceInfo,
            regionIds: regionIds,
            routeName: cruise.itinerary[0].name,
            startPort: _.get(startPort, 'name', ''),
        };
    };
    Mapping.mapFlightCode = function (flight, mandatoryFlight) {
        if (!flight || !mandatoryFlight) {
            return;
        }
        var departureAirport;
        var arrivalAirport;
        switch (flight.direction) {
            case 'O':
                departureAirport = flight.outDepLoc;
                return { departureAirport: departureAirport };
            case 'R':
                arrivalAirport = flight.returnArrLoc;
                return { arrivalAirport: arrivalAirport };
            case 'OJ':
                departureAirport = flight.outDepLoc + '-' + flight.returnArrLoc;
                return { departureAirport: departureAirport };
            case 'RT':
                departureAirport = flight.outDepLoc;
                return { departureAirport: departureAirport };
        }
    };
    return Mapping;
}());
exports.Mapping = Mapping;
//# sourceMappingURL=mapping.js.map